import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { registerUserSuccessful } from "../../store/actions";
import { post } from "../../helpers/api_helper";
import { toast } from "react-toastify";
const PageTwo = (props) => {

  const [email, setEmail] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  const [hide, setHide] = useState(false);
  const [coursetype, setCoursetype] = useState("");
  useEffect(()=>{
    getEmail();
  //  console.log('step two props',props);
  }, []);

  useEffect(()=>{
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  },[])
  const getEmail=async()=>{
    var data = await localStorage.getItem("authUser");
    if(data){
      data=JSON.parse(data);
      setEmail(data?.email);
    }
  }
  const handleValidSubmit = (event, values) => {


    // console.log('step 1 before',values);
    const education =[
      {
        type:'5th pass',
        year:values.five_year,
        mark:values.five_mark,
        totalMark:values.five_totalMark,
        program:values.five_program,
        collage:values.five_schoolName
      },
      {
        type:'8th pass',
        year:values.eight_year,
        mark:values.eight_mark,
        totalMark:values.eight_totalMark,
        program:values.eight_program,
        collage:values.eight_schoolName
      },
      {
        type:'10th pass',
        year:values.ten_year,
        mark:values.ten_mark,
        totalMark:values.ten_totalMark,
        program:values.ten_program,
        collage:values.ten_schoolName

      },
      {
        type:'12th pass',
        year:values.twel_year,
        mark:values.twel_mark,
        totalMark:values.twel_totalMark,
        program:values.twel_program,
        collage:values.twel_schoolName


      },
      {
        type:'diploma',
        year:values.diploma_year,
        mark:values.diploma_mark,
        totalMark:values.diploma_totalMark,
        program:values.diploma_program,
        collage:values.diploma_schoolName

      },
      {
        type:'graduate',
        year:values.bachelor_year,
        mark:values.bachelor_mark,
        totalMark:values.bachelor_totalMark,
        program:values.bachelor_program,
        collage:values.bachelor_schoolName

      },
      {
        type:'post_graduate',
        year:values.master_year,
        mark:values.master_mark,
        totalMark:values.master_totalMark,
        program:values.master_program,
        collage:values.master_schoolName

      },
      {
        type:'phd',
        year:values.phd_year,
        mark:values.phd_mark,
        totalMark:values.phd_totalMark,
        program:values.phd_program,
        collage:values.phd_schoolName


      }
    ]

    let tem = [];
    education.map((item)=>{
      if(item.year){
        tem.push(item);
      }
    })
    console.log('education details',education);
    const body = {
      step:3,
      email:props.email,
      education:tem
    }
    console.log(' details body',body);
    post('/register', body)
      .then((json => {
        console.log('EDUCATIONAL AND PROFESSIONAL QUALIFICATION',json);
        if(json.statusCode==200){
          // props.history.push("/login");
          toast.success(json.message);
          props.onButtonClick(props.expe == true ? "pagethree":"pagefour");
          props.registerUserSuccessful(json);
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          // props.history.push("/index");
        }else{
          toast.error(json.error);
        }
      }))
  }

  const courseType = (e) =>{
    // console.log(e.target.value)
    if(e.target.value == '5th'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == '8th'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == '10th'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == '12th'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == 'Diploma'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == 'Bachelor'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == 'Master'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == 'Phd'){
      setHide(true);
      setCoursetype(e.target.value)
    }else if(e.target.value == ''){
      setHide(false);
      setCoursetype(e.target.value)
    }else{
      setHide(false);
    }
  }
// console.log('coursetype',coursetype)

  return (
    <AvForm
    onValidSubmit={(e, v) => {
      handleValidSubmit(e, v)
    }}
  >
      <Row>
    <Col lg={12}>
      <div className="tab_heading_section">
      <h3 className="heading-title pt-4">Educational and Professional Qualification</h3>
      {/* <AvField type="select" name="select"  label="Qualification Type" >
          <option value="">Select Type</option>
          <option value="5th">5th</option>
          <option value="8th">8th</option>
          <option value="10th">10th</option>
          <option value="12th">12th</option>
          <option value="Diploma">Diploma</option>
          <option value="Bachelor">Bachelor</option>
          <option value="Master">Master</option>
          <option value="Phd">Phd</option>
        </AvField> */}
      </div>
    </Col>
    <Col lg={12}
    className={
      props.coursetype == '5th' ? 'hide-box active':'hide-box'
      || props.coursetype == '' ? 'hide-box':'hide-box'

      }>
      <h5 className="sub-heading-title">5<sup>th</sup> Pass</h5>
      <Row >
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="five_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="five_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="five_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="five_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="five_schoolName"
            placeholder="School Name"
            type="text"
            label="School Name"

          />
        </Col>
      </Row>
    </Col>
    <Col lg={12}
     className={
      props.coursetype == '8th' ? 'hide-box active':'hide-box' && props.coursetype == '' ? 'hide-box ':'hide-box' || props.coursetype == '' ? 'hide-box':'hide-box'
      }>
      <h5 className="sub-heading-title">8<sup>th</sup> Pass</h5>
      <Row >
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="eight_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="eight_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="eight_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="eight_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="eight_schoolName"
            placeholder="School Name"
            type="text"
            label="School Name"

          />
        </Col>
      </Row>
    </Col>
    <Col lg={12}
     className={
     props.coursetype == '10th' ? 'hide-box active':'hide-box'
      && props.coursetype == '12th' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Diploma' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Bachelor' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Master' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Phd' ? 'hide-box active':'hide-box'
      && props.coursetype == '' ? 'hide-box':'hide-box'
      }>
      <h5 className="sub-heading-title">10<sup>th</sup> Pass</h5>
      <Row >
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="ten_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="ten_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="ten_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="ten_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="ten_schoolname"
            placeholder="School Name"
            type="text"
            label="School Name"

          />
        </Col>
      </Row>
    </Col>
    <Col lg={12} className={
      props.coursetype == '12th' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Diploma' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Bachelor' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Master' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Phd' ? 'hide-box active':'hide-box'
       }>
      <h5 className="sub-heading-title">12<sup>th</sup> Pass</h5>
      <Row>
      <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="twel_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="twel_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="twel_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="twel_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="twel_schoolname"
            placeholder="School Name"
            type="text"
            label="School Name"

          />
        </Col>
      </Row>
    </Col>

    <Col lg={12} className={
         props.coursetype == 'Diploma' ? 'hide-box active':'hide-box'
       && props.coursetype == 'Bachelor' ? 'hide-box active':'hide-box'
       && props.coursetype == 'Master' ? 'hide-box active':'hide-box'
       && props.coursetype == 'Phd' ? 'hide-box active':'hide-box'


    }>
      <h5 className="sub-heading-title">Diploma</h5>
      <Row>
      <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="diploma_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="diploma_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="diploma_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="diploma_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="diploma_institute"
            placeholder="Institute Name"
            type="text"
            label="Institute Name"

          />
        </Col>
      </Row>
    </Col>
    <Col lg={12}
      className={
        props.coursetype == 'Bachelor' ? 'hide-box active':'hide-box'
        && props.coursetype == 'Master' ? 'hide-box active':'hide-box'
        && props.coursetype == 'Phd' ? 'hide-box active':'hide-box'
    }>
      <h5 className="sub-heading-title">Bachelor</h5>
      <Row>
      <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="bachelor_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="bachelor_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="bachelor_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="bachelor_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="bachelor_schoolName"
            placeholder="Collage Name"
            type="text"
            label="Collage Name"

          />
        </Col>
      </Row>
    </Col>
    <Col lg={12}
     className={
      props.coursetype == 'Master' ? 'hide-box active':'hide-box'
      && props.coursetype == 'Phd' ? 'hide-box active':'hide-box'
    }
    >
      <h5 className="sub-heading-title">Master</h5>
      <Row>
      <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="master_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="master_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="master_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="master_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="master_schoolName"
            placeholder="Collage Name"
            type="text"
            label="Collage Name"

          />
        </Col>

      </Row>
    </Col>
    <Col lg={12}
     className={
      props.coursetype == 'Phd' ? 'hide-box active':'hide-box'
    }
    >
      <h5 className="sub-heading-title">Phd</h5>
      <Row>
      <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="phd_year"
            placeholder="Passing Year"
            type="month"
            label="Passing Year"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="phd_mark"
            placeholder="Received Marks"
            type="text"
            label="Received Marks"

          />
        </Col>
        <Col lg={2} md={3} sm={6}>
          <AvField
            id=""
            name="phd_totalMark"
            placeholder="total Marks"
            type="text"
            label="total Marks"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="phd_program"
            placeholder="Programme Specialization"
            type="text"
            label="Programme Specialization"

          />
        </Col>
        <Col md={3} sm={6}>
          <AvField
            id=""
            name="phd_schoolName"
            placeholder="Collage Name"
            type="text"
            label="Collage Name"

          />
        </Col>

      </Row>
    </Col>
    {
       props.hide == true ? <>
       <Col lg={12}>
        <AvField type="checkbox" name="avFieldCheckbox" label="I agree that all the above information is accurate to the best of my knowledge."  />
      </Col>
      <FormGroup className="btn_box">
    <Button
      onClick={() => props.onButtonClick("pageone")}
      className="common-btn back_m">Back</Button>
      <Button
      type="submit"
      // onClick={() => props.onButtonClick(props.expe == true ? "pagethree":"pagefour")}
      className="common-btn">Next</Button>
    </FormGroup>
       </>:null
        }

  </Row>
    </AvForm>
  );
};

export default PageTwo;